import { useEffect, useState } from 'react'
import { api } from '../lib/api'
import { useAuth } from '../hooks/useAuth'

export default function LeaderboardPage() {
  const { user } = useAuth()
  const [leaders, setLeaders] = useState<any[]>([])

  useEffect(() => {
    api.getLeaderboard(50).then(({ leaderboard }) => setLeaders(leaderboard)).catch(() => {})
  }, [])

  return (
    <div>
      <div className="page-header">
        <h2>Leaderboard</h2>
        <p>Top warriors ranked by XP. Where do you stand?</p>
      </div>

      <div className="card">
        {/* Header row */}
        <div className="leaderboard-row" style={{ borderBottom: '2px solid rgba(212, 165, 32, 0.2)' }}>
          <span className="form-label" style={{ textAlign: 'center' }}>#</span>
          <span className="form-label">Player</span>
          <span className="form-label" style={{ textAlign: 'right' }}>XP</span>
          <span className="form-label" style={{ textAlign: 'center' }}>Level</span>
        </div>

        {leaders.length === 0 ? (
          <p style={{ color: 'var(--text-secondary)', textAlign: 'center', padding: '2rem 0' }}>
            No players yet. Be the first to claim #1! 🏆
          </p>
        ) : (
          leaders.map((p, i) => {
            const isMe = p.id === user?.id
            const rank = i + 1
            return (
              <div key={p.id} className="leaderboard-row" style={isMe ? { background: 'rgba(212, 165, 32, 0.08)' } : {}}>
                <span className={`leaderboard-rank${rank <= 3 ? ' top-3' : ''}`}>
                  {rank === 1 ? '👑' : rank === 2 ? '🥈' : rank === 3 ? '🥉' : rank}
                </span>
                <div>
                  <span style={{ fontWeight: isMe ? 700 : 500, color: isMe ? 'var(--gold)' : 'var(--text-primary)' }}>
                    {p.displayName || 'Player'}
                  </span>
                  {p.avatar?.stage && (
                    <span className={`avatar-stage stage-${p.avatar.stage.toLowerCase()}`} style={{ marginLeft: '0.5rem', fontSize: '0.45rem' }}>
                      {p.avatar.stage}
                    </span>
                  )}
                </div>
                <span className="font-pixel" style={{ fontSize: '0.6rem', textAlign: 'right', color: 'var(--gold)' }}>
                  {p.xp.toLocaleString()}
                </span>
                <span style={{ textAlign: 'center', fontSize: '0.85rem' }}>
                  Lv.{p.level} {p.streak >= 7 ? '🔥' : ''}
                </span>
              </div>
            )
          })
        )}
      </div>
    </div>
  )
}
